// TODO: Remove or refactor — alpha user payments now handled via SMS payment link on landing page (/member-subscribe)
import { useEffect } from "react";

import { useGetProfile } from "@/features/common/hooks";
import { useAppStore } from "@/stores";
import { UserFeatureFlag, UserStatus } from "@/types";

const useCheckSubscription = () => {
  const { data: user } = useGetProfile();
  const changeSubscription = useAppStore((state) => state.actions.changeSubscription);

  useEffect(() => {
    if (!user) return;

    // Muse or Apple tester
    if (user.role === "muse" || user.featureFlags.includes(UserFeatureFlag.EARLY_TESTER)) {
      return changeSubscription(undefined);
    }

    if (
      !!user.hasInfiniteFreeTrial ||
      (user.freeTrialEndDate ? new Date(user.freeTrialEndDate).valueOf() >= new Date().valueOf() : false)
    ) {
      return changeSubscription(true);
    }
    // Default subscription
    if (user.status === UserStatus.ACTIVE && !!user.subscription) {
      return changeSubscription(true);
    }
    return changeSubscription(false);
  }, [user?.status, user?.subscription, user?.role]);
};

export { useCheckSubscription };
